module.exports = __webpack_public_path__ + "static/media/joint.9f981605.svg";